import environment, { Environment } from "./base";

/*
 * base.ts is the default environment for production.
 * You shouldn't have override anything.
 */

const currentHost = `${window.location.protocol}//${window.location.hostname}`;
const baseApi = `${currentHost}/services/api`;
const tenant = "italcredi";

const env = environment(baseApi, tenant);

const productionEnv: Environment = {
    ...env,
    route: {
        baseRoute: "",
    },
    // override anything that gets added from base.
};

export default productionEnv;
